import App from "./storelocator/app";
import React from "react";
import reactDom from "react-dom/client";

(()=>{
    const element = document.querySelector("#store-locator-app");
    const body = document.querySelector('body');
    if(element && body){
        body.addEventListener('store-locator-ready',function (){
            const rootReact = reactDom.createRoot(element);
            rootReact.render(<App />);
        });
    }
})();
